import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Heart, MapTrifold, PawPrint, ArrowRight } from "@phosphor-icons/react";

const STATS = [
  { icon: Heart, label: "Ranch Goal", value: "$3M", sub: "To build the Wigglez sanctuary", pct: 28, current: "$840K raised" },
  { icon: MapTrifold, label: "Land", value: "300", sub: "Acres secured for the pack", pct: 30, current: "90 acres secured" },
  { icon: PawPrint, label: "Rescued", value: "3,000", sub: "Pit bulls saved & rehomed", pct: 41, current: "1,240 saved so far" },
];

export default function MissionSection() {
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 border-t border-white/5" data-testid="mission-section">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
        <div>
          <p className="overline text-primary mb-2">The Mission</p>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-light max-w-2xl">Every fit funds the fight. <span className="aqua-text">$3M · 300 acres · 3,000 saved.</span></h2>
        </div>
        <p className="text-sm text-muted-foreground max-w-sm">A portion of every Mr. Wigglez drop goes toward the ranch — a home for rescued pit bulls in honor of Smiley, Beats &amp; King.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {STATS.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div key={s.label} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.08 }}
              className="p-7 rounded-2xl bg-card border border-white/10" data-testid={`mission-stat-${s.label.toLowerCase()}`}>
              <Icon weight="duotone" size={26} className="text-primary mb-4" />
              <div className="flex items-baseline gap-2">
                <span className="text-4xl font-modern font-semibold">{s.value}</span>
                <span className="overline text-muted-foreground">{s.label}</span>
              </div>
              <p className="text-sm text-muted-foreground mt-1 mb-4">{s.sub}</p>
              <div className="h-2 rounded-full bg-muted overflow-hidden">
                <motion.div initial={{ width: 0 }} whileInView={{ width: `${s.pct}%` }} viewport={{ once: true }} transition={{ duration: 1, delay: 0.2 }}
                  className="h-full rounded-full bg-primary" />
              </div>
              <p className="text-xs text-muted-foreground mt-2">{s.current}</p>
            </motion.div>
          );
        })}
      </div>

      <div className="mt-8">
        <Link to="/hub" className="inline-flex items-center gap-2 overline text-primary hover:opacity-80">Join the movement in Mr Hub <ArrowRight size={14} /></Link>
      </div>
    </section>
  );
}
